import * as React from 'react';
import Button from 'components/Button';

type IntroProps = {
  screeningTool: {
    health_concern_type?: string;
    label: string;
    overview?: string;
    url?: string;
  };
  onStart: () => void;
  show: boolean;
};

const Intro: React.FC<IntroProps> = ({ screeningTool, onStart, show }) => {
  if (!show) return null;

  return (
    <div className="items-center">
      <div className="flex flex-col justify-center md:p-8 rounded-lg md:shadow-md mb-8 mt-2 md:mt-8">
        <div className="text-sm uppercase tracking-wide text-gray-400 font-semibold mb-2">
          {screeningTool.health_concern_type || "Health Concern"}
        </div>
        <h1 className="text-lg md:text-xl font-semibold text-primary-700 mb-3">
          {screeningTool.label}
        </h1>
        <p className="text-base text-primary-700 md-4 md:mt-8 mb-4 max-w-xl">
          {screeningTool.overview}
        </p>
        <div className="flex justify-between items-center w-full mb-6 mt-8">
          {screeningTool.url && (
            <a
              href={screeningTool.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-700 underline hover:text-blue-900"
            >
              Learn more
            </a>
          )}
          <div className="flex-1" />
          <Button
            type="button"
            onClick={onStart}
            variant="primary"
          >
            Begin Screener
          </Button>
        </div>
      </div>
      <div className='mt-8 mb-6 p-4 bg-gray-50 border-l-4 border-blue-400 rounded'>
        <p className="text-sm">
          This screening tool is for informational purposes only and does not constitute a diagnosis.
        </p>
      </div>
    </div>
  );
};

export default Intro;
